<template>
  <div>
    <v-card-title class="justify-center text-h5">
      {{ $t("protocolLabel") }}
    </v-card-title>
    <div class="text-right">
      <v-btn @click="showFilters = !showFilters" color="primary">
        <template v-if="showFilters">
          <v-icon left>mdi-eye-off</v-icon>
          {{ $t('hideFiltersLabel') }}
        </template>
        <template v-else>
          <v-icon left>mdi-eye</v-icon>
          {{ $t('showFiltersLabel') }}
        </template>
      </v-btn>
    </div>
    <div v-if="showFilters">
      <div class="body-1 mb-2">{{ $t("filterByLabel") }}</div>
      <div class="d-flex">
        <v-col cols="2" class="pa-0 mr-4">

          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
              hide-details
                outlined
                clearable
                @click:clear="clearDate"
                dense
                v-model="selectedDate"
                :label="$t('startDateLabel')"
                readonly
                v-bind="attrs"
                v-on="on"
              >
              </v-text-field>

            </template>
            <v-date-picker
              color="primary"
              v-model="selectedDate"
              @input="menu = false"
              :locale="$i18n.locale"
            ></v-date-picker>



          </v-menu>
        </v-col>
        <v-col cols="2" class="pa-0 mr-4">
          <v-menu
                  v-model="menuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                      hide-details
                      outlined
                      clearable
                      @click:clear="clearDateTo"
                      dense
                      v-model="selectedDateTo"
                      :label="$t('endDateLabel')"
                      readonly
                      v-bind="attrs"
                      v-on="on"
              >
              </v-text-field>

            </template>
            <v-date-picker
                    color="primary"
                    v-model="selectedDateTo"
                    @input="menuTo = false"
                    :locale="$i18n.locale"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="pa-0">
          <v-autocomplete
            hide-details
            class="mr-4"
            dense
            outlined
            v-model="selectedUser"
            :items="users"
            item-text="userName"
            item-value="userId"
            :label="$t('userLabel')"
            clearable
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="3" class="pa-0 mt-n3" v-if="canArchiveLogs()">
          <v-checkbox
                  v-model="showArchived"
                  :label="$t('showArchivedLabel')"
          ></v-checkbox>
        </v-col>
        <v-col cols="2" class="ml-auto d-flex mt-n3">
          <div class="filter" style="width:100%">
            <v-btn @click="page = 1; filter(); filterEnabled()" width="100%" color="primary" height="100%">
              <v-icon left >mdi-filter</v-icon> {{$t('filterLabel')}}
            </v-btn>
          </div>
          <div class="reset pl-4" v-if="filtered">
            <v-btn @click="page = 1; filterDisabled()" width="100%" color="red" height="100%">
              <v-icon color="white">mdi-restore</v-icon>
            </v-btn>
          </div>
        </v-col>
      </div>
    </div>
    <v-data-table
      :options.sync="options"
      :footer-props="protocol.footerProps"
      :server-items-length="1"
      :page.sync="page"
      :items-per-page="amount"
      class="mb-5"
      :hide-header="true"
      :headers="protocol.headers"
      :items="protocol.values"
      :loading-text="$t('tableLoadingLabel')"
      :loading = "loading"
    >
         <template v-slot:item.domainLogDate="{ item }">
           <span>{{new Date(item.domainLogDate).toLocaleString()}}</span>
         </template>
      <template #item.actions="{ item }" v-if="canArchiveLogs()">
        <v-btn icon x-small outlined fab dark color="grey darken-1" @click="archiveProtocolEventHandler(item)">
          <v-icon>mdi-archive-arrow-up</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        {{$t('noDataAvailable')}}
      </template>
      <template v-slot:no-results>
        {{$t('noDataAvailable')}}
      </template>
    </v-data-table>
    <v-pagination
      v-model="page"
      :length="pageCount"
      :total-visible="20"
      @input="filter()"
    ></v-pagination>

    <!-- <div v-for="(event,index) in timeline" :key="index"
        class="list-item px-5 py-5 align-center justify-space-between ">
        <div class="text-body-2">{{event.text}}</div>
        <div class="text-caption primary--text">{{event.date}} - 12:44:24</div>
        <div class="body-2">Wertheim Admin</div>
      </div> -->
    <v-dialog v-model="archiveProtocolDialog" max-width="500px">
      <v-card class="pa-10">
        <v-card-title class="justify-center">{{
          $t("archiveProtocolTitle")
          }}</v-card-title>
        <v-card-actions>
          <v-row>
            <v-col cols="6">
              <v-btn @click="archiveProtocolRequest" width="100%" small color="red white--text">OK</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn width="100%" small color="primary" @click="archiveProtocolDialog = false">
                {{ $t("cancelLabel") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import UserTypes from "../auth/userTypes";
export default {
  data() {
    return {
      options: {},
      filtered: false,
      loading: false,
      selectedDate: "",
      selectedDateTo: "",
      selectedUser: "",
      page: 1,
      dates: ["", ""],
      pageCount: 3,
      amount: 10,
      itemsPerPage: 1,
      sortBy:'',
      sortDesc: null,
      users: [],
      menu: false,
      menuTo: false,
      showArchived: false,
      archiveProtocolDialog: false,
      selectedProtocolId: '',
      showFilters: false,
      protocol: {
        search: "",
        headers: [
          {
            text: this.$t('protocolMessageLabel'),
            value: "domainLogText",
          },
          {
            text: this.$t('protocolDateLabel'),
            value: "domainLogDate",
          },
          {
            text: this.$t('protocolUserLabel'),
            value: "userLastName",
          },
          {
            text: "",
            sortable: false,
            value: "actions",
            align: "end",
          },
        ],
        values: [],
        footerProps:{
          'items-per-page-options' : [5, 10, 15, 20, -1],
          'disable-pagination': true,
          'next-icon': null,
          'prev-icon': null,
          'page-text' : '',
          'items-per-page-all-text': this.$t('allLabel'),
          'items-per-page-text': this.$t('rowsPerPageLabel')
        }
      },
    };
  },
  watch: {
      options: {
        handler(){
          const options = this.options;
          this.amount = options.itemsPerPage
          const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : '';
          const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : null;
          this.sortBy = sortBy;
          this.sortDesc = sortDesc;
          this.filter();
        },
        deep: true
      }
  },
  methods: {
    canArchiveLogs() {
      let userType = parseInt(this.$store.state.user.userType);
      return userType === UserTypes.WertheimAdministrator;
    },
    archiveProtocolEventHandler(protocol) {
      this.selectedProtocolId = protocol.id;
      this.archiveProtocolDialog = true;
    },
    archiveProtocolRequest() {
      this.axios
        .delete("/api/protocol/archive", {
          params: {
            id: this.selectedProtocolId,
          },
        })
        .then(() => {
          let index = this.protocol.values.findIndex(x => x.id === this.selectedProtocolId);
          this.protocol.values.splice(index, 1)
          this.archiveProtocolDialog = false
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clearDate() {
      this.selectedDate = "";
    },
    clearDateTo() {
      this.selectedDateTo = "";
    },
    filterEnabled(){
      this.filtered = true
    },
    filterDisabled(){
      this.filtered = false
      this.selectedDate = ''
      this.selectedDateTo = ''
      this.selectedUser = ''
      this.showArchived = false
      this.filter()
    },
    async filter(){
      this.loading = true
        const dataParams = {
          languageId: 1,
          amount: this.amount,
          selectedCompanyId: this.selectedCompany ? this.selectedCompany : '',
          selectedUserId: this.selectedUser,
          status: '',
          startDate: this.selectedDate,
          endDate: this.selectedDateTo,
          page: this.page,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
          showArchived: this.showArchived
        }
      // const WertheimSales = {
      //   isWertheimSales: true,
      //   isSalesPartnershipAdmin: false,
      //   isSalesPartnershipSales: false,
      //   isSalesPartnershipProductConfigurator: false,
      //   isAffiliatePartnershipSales: false,
      //   amount: this.amount,
      //   languageId: 1,
      //   companyId: '',
      //   spPartnerCompanyId: '',
      //   userId: this.selectedUser,
      //   status: '',
      //   startDate: this.selectedDate,
      //   page: this.page,
      // }
      // const SalesPartnershipAdmin = {
      //   isWertheimSales: false,
      //   isSalesPartnershipAdmin: true,
      //   isSalesPartnershipSales: false,
      //   isSalesPartnershipProductConfigurator: false,
      //   isAffiliatePartnershipSales: false,
      //   languageId: 1,
      //   amount: this.amount,
      //   companyId: this.$store.getters.getCurrentUser.companyId,
      //   spPartnerCompanyId: this.selectedCompany ? this.selectedCompany : '',
      //   userId: this.selectedUser,
      //   status: '',
      //   startDate: this.selectedDate,
      //   page: this.page,
      // }
      // const SalesPartnershipSales = {
      //   //smundet me filtru me kompani
      //   isWertheimSales: false,
      //   isSalesPartnershipAdmin: false,
      //   isSalesPartnershipSales: true,
      //   isSalesPartnershipProductConfigurator: false,
      //   isAffiliatePartnershipSales: false,
      //   languageId: 1,
      //   amount: this.amount,
      //   companyId: '',
      //   spPartnerCompanyId: this.selectedCompany ? this.selectedCompany : '',
      //   userId: this.$store.getters.getCurrentUser.userId,
      //   status: '',
      //   startDate: this.selectedDate,
      //   page: this.page,
      // }
      // const AffiliatePartnershipSales = {
      //   //nuk mundet me filtru me kompani
      //   isWertheimSales: false,
      //   isSalesPartnershipAdmin: false,
      //   isSalesPartnershipSales: false,
      //   isSalesPartnershipProductConfigurator: false,
      //   isAffiliatePartnershipSales: true,
      //   languageId: 1,
      //   amount: this.amount,
      //   companyId: '',
      //   userId: this.$store.getters.getCurrentUser.userId,
      //   status: '',
      //   startDate: this.selectedDate,
      //   page: this.page,
      // }
      // const SalesPartnershipProductConfigurator = {
      //   //nuk mundet me filtru me kompani
      //   isWertheimSales: false,
      //   isSalesPartnershipAdmin: false,
      //   isSalesPartnershipSales: false,
      //   isSalesPartnershipProductConfigurator: true,
      //   isAffiliatePartnershipSales: false,
      //   languageId: 1,
      //   amount: this.amount,
      //   companyId: '',
      //   userId: this.$store.getters.getCurrentUser.userId,
      //   status: '',
      //   startDate: this.selectedDate,
      //   page: this.page,
      // }

      // var dataParams;

      // if (this.$store.state.user.userType == UserTypes.WertheimSales) {
      //   dataParams = WertheimSales
      // } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipAdmin) {
      //   dataParams = SalesPartnershipAdmin
      // } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipSales) {
      //   dataParams = SalesPartnershipSales
      // } else if (this.$store.state.user.userType == UserTypes.AffiliatePartnershipSales) {
      //   dataParams = AffiliatePartnershipSales
      // } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipProductConfigurator) {
      //   dataParams = SalesPartnershipProductConfigurator
      // }
      // else {
      //   dataParams = WertheimAdmin
      // }

        this.axios
          .get("/api/protocol/filterProtocol", {
            params: dataParams
          })
          .then((response) => {
            if(!this.users.length){
              this.users = response.data.users;
            }
            this.protocol.values = response.data.filteredDomainLogs;
            this.pageCount = response.data.pages;
            this.loading = false;
          })
          .catch((error) => {
            const snackbar = {
              show: true,
              message: error.message,
            };
            this.$EventBus.$emit("snackbar", snackbar);
            this.loading = false;
          });
      },
  },
  mounted() {
    this.filter()
  },
};
</script>

<style lang="scss" scoped>
.list-item {
  border: 1px solid rgb(224, 224, 224);

  &:last-child {
    border-bottom: 0px;
  }

  &:nth-child(odd) {
    background: #f8f8f8;
  }
}
</style>